module.exports = __webpack_public_path__ + "img/img_interior07.9fee527b.jpg";